import cssUtil from 'gw-portals-util-js/CssUtil';

import styles from './EmployeeClassesCode-hashed.scss';
import template from 'text!./EmployeeClassesCode.html';

export default [() => ({
    restrict: 'E',
    scope: {
        match: '=',
        query: '='
    },
    template: cssUtil.hashTemplate(template, styles)
})];